/* eslint-disable react/forbid-component-props */
import { Stack, SxProps, Typography, useMediaQuery } from '@mui/material';
import { BenefitsGrayReturns } from '@/components/blocks/BenefitsGray/parts/Returns';
import { BenefitsGrayShipment } from '@/components/blocks/BenefitsGray/parts/Shipment';
import { BenefitsGrayPay } from '@/components/blocks/BenefitsGray/parts/Pay';
import { BenefitsGrayCard } from '@/components/blocks/BenefitsGray/parts/Card';
import {
	BenefitsGrayContentSX,
	BenefitsGrayDescriptionSX,
	BenefitsGrayFrameSX,
	BenefitsGrayItemSX,
	BenefitsGraySlideInnerSX,
	BenefitsGrayTitleSX,
} from '@/components/blocks/BenefitsGray/styles/main';
import { combineSX } from '@/utils/combineSX';
import { useTheme } from '@mui/material/styles';
import { CarouselProvider, Slider } from 'pure-react-carousel';
import { CarouselSlide } from '@/components/blocks/Carousel/CarouselSlide';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';

const ITEMS = [
	{
		title: '30 días para cambios y devoluciones',
		description: 'sin complicaciones',
		icon: <BenefitsGrayReturns />,
	},
	{
		title: 'Envío gratis a todo méxico',
		description: 'en compras +$999',
		icon: <BenefitsGrayShipment />,
	},
	{
		title: 'Compra en línea y paga en efectivo',
		description: 'en OXXO y BBVA',
		icon: <BenefitsGrayPay />,
	},
	{
		title: 'Elige el método de pago que prefieras',
		description: 'pagos sin preocupaciones',
		icon: <BenefitsGrayCard />,
	},
];

const defaultCarouselProps = {
	naturalSlideWidth: 248,
	naturalSlideHeight: 300,
	visibleSlides: 1,
	step: 1,
	infinite: true,
	dragEnabled: false,
	totalSlides: 1,
	isIntrinsicHeight: true,
};

interface BenefitsGrayProps {
	sx?: SxProps;
}

export const BenefitsGray: React.FC<BenefitsGrayProps> = ({ sx }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<DpBottomContainer
			benefitGray
			framesx={combineSX([BenefitsGrayFrameSX, ...(Array.isArray(sx) ? sx : [sx])])}
			sx={BenefitsGrayContentSX}
		>
			{isMobile ? (
				<CarouselProvider
					isPlaying
					interval={8000}
					{...defaultCarouselProps}
					totalSlides={ITEMS.length}
				>
					<Slider style={{ overflow: 'hidden' }}>
						{ITEMS.map((item, index) => (
							<CarouselSlide
								index={index}
								key={`id_carousel_${index}`}
								sx={BenefitsGraySlideInnerSX}
							>
								<Stack key={item.title} sx={BenefitsGrayItemSX}>
									{item.icon}
									<Typography sx={BenefitsGrayTitleSX}>{item.title}</Typography>
									<Typography sx={BenefitsGrayDescriptionSX}>{item.description}</Typography>
								</Stack>
							</CarouselSlide>
						))}
					</Slider>
				</CarouselProvider>
			) : (
				<>
					{ITEMS.map((item) => (
						<Stack key={item.title} sx={BenefitsGrayItemSX}>
							{item.icon}
							<Typography sx={BenefitsGrayTitleSX}>{item.title}</Typography>
							<Typography sx={BenefitsGrayDescriptionSX}>{item.description}</Typography>
						</Stack>
					))}
				</>
			)}
		</DpBottomContainer>
	);
};
